// @flow
import {
  FETCH_SOURCES_START,
  FETCH_SOURCES_SUCCESS,
  FETCH_SOURCES_FAILED,
  FETCH_SOURCES_REQUEST,
} from './actionTypes';
import { guardNullOrUndefined } from '../../utils/guards';

export const fetchSourcesRequest = (): TrovitAction => ({
  type: FETCH_SOURCES_REQUEST,
});

export const fetchSourcesStart = (): TrovitAction => ({ type: FETCH_SOURCES_START });

export const fetchSourcesSuccess = (data: Array<Source>): TrovitAction => {
  guardNullOrUndefined(data);
  return { type: FETCH_SOURCES_SUCCESS, payload: data };
};

export const fetchSourcesFailed = (error: string): TrovitAction => ({
  type: FETCH_SOURCES_FAILED,
  payload: error,
});



// WEBPACK FOOTER //
// ./app/Sources/list/actions.js